<template>
    <v-dialog
        v-model="isDialogOpen"
        persistent
        max-width="640">
        <v-card>
          <v-card-title class="title-form">
            {{isEdit ? 'Editar extra':'Agregar extra'}}
          </v-card-title>
            <v-card-text>

              <div class="container-form">

                <v-text-field
                  label="Nombre del extra"
                  placeholder="Nombre del extra"
                  v-model="extra.name"
                  color="#222222"
                  variant="underlined"
                  type="text"
                  :rules="rules.required"/>

                <v-text-field
                  label="Precio unitario con IVA"
                  placeholder="Precio unitario con IVA"
                  v-model="extra.price"
                  color="#222222"
                  variant="underlined"
                  type="number"
                  :rules="rules.required"/>

                <v-select
                  label="Asociar a POS"
                  v-model="extra.terminal"
                  :items="pos"
                  :rules="rules.required"
                  item-title="name"
                  item-value="_id"
                  variant="underlined"/>

              </div>
            </v-card-text>
            <v-card-actions>
            <v-btn
            class="btn-cancel-form"
            color="#6E6E6E"
                variant="text"
                rounded="xl"
                @click="isDialogOpen = false">
                Cancelar
            </v-btn>

            <v-btn
                class="btn-action-form"
                rounded="xl"
                color="#FFFFFF"
                :loading="isSavingData"
                :disabled="disableBtn()"
                @click="actionBtn">
                Guardar
            </v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import terminalsApi from '@/api/terminalsApi'
import extrasApi from '@/api/extrasApi'
export default {
  name: 'CommerciaVueAddEditExtras',
  emits: ['refreshList'],
  data () {
    return {
      validData: true,
      isSavingData: false,
      isDialogOpen: false,
      isEdit: false,
      business: this.$store.getters.business,
      pos: [],
      extra: this.initObj(),
      rules: {
        required: [
          v => !!v || 'Campo requerido.'
        ]
      }
    }
  },
  created () {
    this.getPos()
  },
  methods: {
    initObj () {
      return {
        name: null,
        price: null,
        business: null,
        terminal: null,
        available: null,
        created_at: null,
        updated_at: null,
        _id: null
      }
    },
    add () {
      this.extra = this.initObj()
      this.extra._id = '-'
      this.extra.updated_at = Date.now()
      this.extra.created_at = Date.now()
      this.extra.business = this.business._id
      this.extra.available = true
      this.isDialogOpen = true
      this.isEdit = false
    },
    edit (obj) {
      this.isDialogOpen = true
      this.isEdit = true
      this.extra = structuredClone(obj)
    },
    disableBtn () {
      return (Object.values(this.extra).some(value => value === null || value === ''))
    },
    actionBtn () {
      if (this.isEdit) {
        this.editExtra()
      } else {
        this.addExtra()
      }
    },
    async getPos () {
      this.pos = await terminalsApi.list(this.business._id, '')
    },
    async addExtra () {
      if (await extrasApi.add(this.extra)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
      }
    },
    async editExtra () {
      if (await extrasApi.edit(this.extra)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
      }
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/forms.css';
</style>
